<h1 mat-dialog-title>
    {{ this.inventur.name }}
</h1>
<div mat-dialog-actions>
    <button mat-button (click)="close()">Abbrechen</button>
    <button mat-flat-button (click)="save()" color="accent">Löschen</button>
</div>
